import cx from 'classnames';
import React, { CSSProperties, InputHTMLAttributes, memo } from 'react';
import s from './BTextarea.module.scss';

export interface BTextareaProps extends InputHTMLAttributes<HTMLTextAreaElement> {
    className?: string;
    disabled?: boolean;
    errorMessage?: string;
    height?: string;
    width?: string;
}

export const BTextarea = memo<BTextareaProps>((props: BTextareaProps) => {
  const {
    className,
    disabled,
    value,
    errorMessage,
    onChange,
    width,
    height,
    ...otherProps
  } = props;

  const modsInput = {
    [s.isErrorMessage]: Boolean(errorMessage),
    [s.isTyping]: Boolean(value),
  };

  const textAreaSize: CSSProperties = {
    width,
    height,
  };

  return (
  // eslint-disable-next-line jsx-a11y/label-has-associated-control
    <label className={cx(s.feTextarea, className)} style={textAreaSize}>
      <textarea
        {...otherProps}
        disabled={disabled}
        value={value}
        onChange={onChange}
        className={cx(s.textarea, modsInput)}
      />
      {errorMessage && <span className={s.messageError}>{errorMessage}</span>}
    </label>
  );
});
